import React from 'react'
import { Pipeline } from '@morningtrain/react-helpers'
import TriggerPipelineOnBeforeNavigate from './TriggerPipelineOnBeforeNavigate'

export default function OnBeforeNavigatePipeline ({ children }) {
  return (
    <Pipeline>
      <TriggerPipelineOnBeforeNavigate />
      {children}
    </Pipeline>
  )
}
